<template>
  <div class="usage-chart-container">
    <!--  TODO Replace with new TW spinner -->
    <VLoadingSpinner v-if="usage === {}" size="medium" />
    <svg v-else id="usage-chart" viewBox="0 0 40 40">
      <path class="chart-background" d="M20 4 a 16 16 0 0 1 0 32 a 8 8 0 0 1 0 -32" />
      <path
          class="chart-foreground"
          d="M20 4 a 16 16 0 0 1 0 32 a 8 8 0 0 1 0 -32"
          stroke-linecap="round"
          :stroke-dasharray="`${strokeValue}, 100`" />
      <text x="20" y="20" class="sent">{{ usage }}</text>
      <text x="20" y="25" class="allowance">{{ $t('companySettings.billing.usageDisplayWidget.usageDisplayOf') }} {{ allowance }}</text>
    </svg>
  </div>
</template>

<script>
import VLoadingSpinner from '@/components/deprecated/atoms/LoadingSpinner.vue';

export default {
  name: 'VUsageDisplayChart',
  components: {
    VLoadingSpinner,
  },
  data() {
    return {
      loading: true,
    };
  },
  props: {
    usage: {
      type: Number,
      required: true,
    },
    allowance: {
      type: Number,
      required: true,
    },
  },
  computed: {
    strokeValue() {
      return (this.usage / this.allowance) * 100;
    },
  },
};

</script>

<style scoped>
#usage-chart {
  fill: none;
  width: 40%;
}
.chart-background {
  fill: none;
  stroke: var(--signable-secondary-3-shade-3);
  stroke-width: 3.5;
}
.chart-foreground {
  fill: none;
  stroke: var(--signable-secondary-1);
  stroke-width: 2.5;
  transition: 1s ease all;
}
.sent {
  fill: var(--signable-secondary-2);
  font-weight: bold;
  font-size: 0.5em;
  text-align: center;
  text-anchor: middle;
}
.allowance {
  fill: var(--signable-secondary-3);
  font-size: 0.2em;
  text-align: center;
  text-anchor: middle;
}
.usage-chart-container {
  position: relative;
  min-height: 100px;
}
</style>
